import makeStyles from '@mui/styles/makeStyles'

const useLogReportStyles = makeStyles({
  root: {
    '& MuiPickersDay-daySelected': {
      backgroundColor: 'white',
      boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
      borderRadius: '50px',
      border: 'none',
      '&:hover': {
        backgroundColor: 'white',
        border: 'none',
      },
    },

    '& .MuiInputBase-root': {
      color: '#000',
      borderRadius: '50px',
      border: 'none',
      fontSize: '12px',
      justifyContent: 'center',
    },
    '& MuiPickersDay-daySelected': {
      backgroundColor: 'white',
      border: 'none',
      '&:hover': {
        backgroundColor: 'white',
        border: 'none',
      },
    },
  },
})

export default useLogReportStyles
